// layoutHelpers.js

export const matchMargin = 40;
export const fallbackMatchHeight = 72;

export function generateMatchTops(
  bracketData,
  measuredHeights = {}
) {
  const rounds = bracketData?.rounds || [];

  if (!rounds.length) {
    return {
      matchTops: [[]],
      visibleMatchIndexes: [],
    };
  }

  const matchTops = rounds.map(() => []);

  const getHeight = (match) =>
    measuredHeights[match?.matchId] || fallbackMatchHeight;

  // -----------------------------
  // ROUND 1
  // Preserve ALL structural slots,
  // including spacers.
  // -----------------------------
  let currentTop = 0;

  rounds[0].forEach((match, matchIndex) => {
    matchTops[0][matchIndex] = currentTop;

    currentTop += getHeight(match) + matchMargin;
  });

  const visibleMatchIndexes = rounds[0]
    .map((match, index) =>
      !match.isBye ? index : null
    )
    .filter((index) => index !== null);

  // -----------------------------
  // REMAINING ROUNDS
  // -----------------------------
  for (
    let roundIndex = 1;
    roundIndex < rounds.length;
    roundIndex++
  ) {
    const round = rounds[roundIndex];
    const previousRound = rounds[roundIndex - 1];

    round.forEach((match, matchIndex) => {
      const parentCenters = [];

      ["teamA", "teamB"].forEach((slot) => {
        const sourceMatchId =
          match?.[slot]?.sourceMatchId;

        if (!sourceMatchId) return;

        const parentIndex =
          previousRound.findIndex(
            (parent) =>
              parent.matchId === sourceMatchId
          );

        if (parentIndex === -1) return;

        const parentTop =
          matchTops[roundIndex - 1][parentIndex];

        if (typeof parentTop !== "number") return;

        const parentHeight =
          getHeight(previousRound[parentIndex]);

        parentCenters.push(
          parentTop + parentHeight / 2
        );
      });

      const matchHeight = getHeight(match);

      // Match fed by previous-round games
      if (parentCenters.length) {
        const center =
          parentCenters.reduce(
            (sum, value) => sum + value,
            0
          ) / parentCenters.length;

        matchTops[roundIndex][matchIndex] =
          center - matchHeight / 2;

        return;
      }

      // Directly seeded / bye-advanced match.
      // IMPORTANT: it still needs a position.
      const previousHeight =
        previousRound[matchIndex]
          ? getHeight(previousRound[matchIndex])
          : fallbackMatchHeight;

      const previousTop =
        matchTops[roundIndex - 1][matchIndex];

      if (typeof previousTop === "number") {
        matchTops[roundIndex][matchIndex] =
          previousTop +
          (previousHeight - matchHeight) / 2;
      } else {
        matchTops[roundIndex][matchIndex] =
          matchIndex *
          (fallbackMatchHeight + matchMargin);
      }
    });
  }

  return {
    matchTops,
    visibleMatchIndexes,
  };
}